import { useEffect, useRef, useState } from "react";
import BuildingModel from "../components/building-model.tsx";
import PropertyInput from "../components/inputs/input-property.tsx";
import InputSelectGebaeudetyp from "../components/inputs/input-select-gebaeudetyp.tsx";
import {H, ViewCopy, ViewDialog} from "../components/view.tsx";
import { useStore } from "../state/state.ts";

export default function ViewBase1() {
  return (<ViewDialog ><ViewBase1Form /> </ViewDialog>)
}

export function ViewBase1Form() {
  const timeout = useRef(null);
  const [adress, set_address] = useState<[string, string, string]>(["", "", ""]);
  const glb_url_store = useStore((state) => state.glb_url);
  const features = useStore((state) => state.features);
  const postleitzahl = useStore((state) => state.postleitzahl);
  const strasse = useStore((state) => state.strasse);
  const hausnummer = useStore((state) => state.hausnummer);
  const get_property = useStore((state) => state.get_property);
  const has_feature = useStore((state) => state.has_feature);
  const api_building_geometry = useStore((state) => state.api_building_geometry);

  const update_geometry = async ()=>{
      console.log(has_feature('geo3d'),postleitzahl, hausnummer, strasse );

      if (has_feature('geo3d') && (postleitzahl != adress[0] || strasse != adress[1] || hausnummer != adress[2]) && postleitzahl != undefined && strasse != undefined && hausnummer != undefined) {
        set_address([postleitzahl, strasse, hausnummer]);
        await api_building_geometry();
      }
    }
  useEffect(()=>{
    if (timeout.current) {
      clearTimeout(timeout.current)
    }

    timeout.current = setTimeout(update_geometry, 3000);
  },[postleitzahl, strasse, hausnummer]);

  return (<>
            
            {
              has_feature('geo3d') ? <>
                <ViewCopy><H>Wie ist die Adresse der Immobilie?</H></ViewCopy>
                <PropertyInput placeholder_prefix="z.B." type={"postleitzahl"}/>
                <PropertyInput placeholder_prefix="z.B." type={"strasse"}/>
                <PropertyInput placeholder_prefix="z.B." type={"hausnummer"}/>
                <InputSelectGebaeudetyp/>
                <BuildingModel/>  
              </> 
              : 
              <>
                <ViewCopy><H>Um welches Gebäude handelt es sich?</H></ViewCopy>
                <PropertyInput type="gebaeude_typ"/> 
              </>
              
            }
            
          </>)
}